/* eslint-env es6 */
/* eslint-disable no-restricted-syntax */

import {v4 as uuid} from "uuid";

/* global dataLayer */
window.dataLayer = window.dataLayer || [];

// #region Facebook pixel
/* global fbq */
!(function (f, b, e, v, n, t, s) {
	if (f.fbq) {
		return;
	}
	n = f.fbq = function () {
		n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
	};
	if (!f._fbq) {
		f._fbq = n;
	}
	n.push = n;
	n.loaded = !0;
	n.version = "2.0";
	n.queue = [];
	t = b.createElement(e);
	t.async = !0;
	t.src = v;
	s = b.getElementsByTagName(e)[0];
	s.parentNode.insertBefore(t, s);
})(
	window,
	document,
	"script",
	"https://connect.facebook.net/en_US/fbevents.js"
);
fbq("init", AoPS.bd.fbq);
if (AoPS.isProduction) {
	fbq("track", "PageView");
}
// #endregion Facebook pixel

{
	/** @deprecated We now use a service called stape to do capi things */
	class Numbers {
		constructor() {
			this.eventId = uuid();
			dataLayer.push({eventID: this.eventId});
		}

		/**
		 * Always call this method after consuming an `eventId`
		 * @returns The new, random UUID
		 */
		regenEventId() {
			this.eventId = uuid();
			dataLayer.push({eventID: this.eventId});
			return this.eventId;
		}

		/**
		 * Get the user's ID if they are logged in
		 * @returns {Number|void} An integer > 1 or nothing
		 */
		getUser() {
			if (!AoPS.session.logged_in) {
				return;
			}
			const user = AoPS.session.user_id;
			if (!(Number.isInteger(user) || user > 1)) {
				return;
			}
			return user;
		}

		/**
		 *
		 * Send an event to /numbers/ajax
		 * @param {object} params The query-string parameters of the AJAX event,
		 * e.g.
		 * ```js
		 * {
		 * a: 'some_action', // Must at least have this!
		 * thing1: 'some data',
		 * thing2: 'some other data',
		 * }
		 * ```
		 * @deprecated We now use a service called stape to do capi things.
		 * 	Per PROJ-25440 and a later Academy2 bug, just don't do anything here
		 */
		sendEvent(params) {
			return Promise.resolve();
		}
	}

	AoPS.Numbers = new Numbers();
}
